import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-desktop",
  "use": "icon-desktop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-desktop\"><path fill=\"#ffffff\" d=\"M896 96H128c-35.2 0-64 28.8-64 64v512c0 35.2 28.8 64 64 64h352v128h-160c-19.2 0-32 12.8-32 32s12.8 32 32 32h384c19.2 0 32-12.8 32-32s-12.8-32-32-32h-160v-128h352c35.2 0 64-28.8 64-64V160c0-35.2-28.8-64-64-64z m0 576H128V160h768v512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol